// extracted by mini-css-extract-plugin
export default {"container":"XnDVyRV_FJ2BQQCfoXNr","iconContainer":"SOx6NverQ8iN43FDsFXt"};